import { Map, GeoJSONSource } from 'maplibre-gl'
import { IWaypoint } from '../../../services/rides/rides'
import { useEffect } from 'react'
import PickupPng from '../../../assets/map/pickup.png'
import DropoffPng from '../../../assets/map/dropoff.png'

interface IProps {
  map?: Map
  ride: {
    start_lat: number
    start_lon: number
    destination_lat: number
    destination_lon: number
  } | null
  waypoints: IWaypoint[]
}

const RideMarkers = ({ map, ride, waypoints }: IProps) => {
  useEffect(() => {
    if (!map) return
    map.loadImage(PickupPng, (error, image) => {
      if (error) throw error
      map.addImage('pickup-marker', image as ImageBitmap)
    })
    map.loadImage(DropoffPng, (error, image) => {
      if (error) throw error
      map.addImage('dropoff-marker', image as ImageBitmap)
    })

    map.addSource('pickup-marker', {
      type: 'geojson',
      data: {
        type: 'Feature',
        geometry: {
          type: 'Point',
          coordinates: [0, 0]
        },
        properties: {
          heading: 0
        }
      }
    })
    map.addSource('dropoff-marker', {
      type: 'geojson',
      data: {
        type: 'Feature',
        geometry: {
          type: 'Point',
          coordinates: [0, 0]
        },
        properties: {
          heading: 0
        }
      }
    })
    map.addLayer({
      id: 'pickup-marker',
      type: 'symbol',
      source: 'pickup-marker',
      layout: {
        'icon-image': 'pickup-marker',
        'icon-size': 0.3,
        'icon-padding': 1,
        'icon-allow-overlap': true
      }
    })
    map.addLayer({
      id: 'dropoff-marker',
      type: 'symbol',
      source: 'dropoff-marker',
      layout: {
        'icon-image': 'dropoff-marker',
        'icon-size': 0.3,
        'icon-padding': 1,
        'icon-allow-overlap': true
      }
    })
  }, [map])

  useEffect(() => {
    renderMarkers()
  }, [ride, waypoints])

  // Helper function to set source data
  const setSourceData = (map: Map, source_id: string, lon: number, lat: number): void => {
    (map.getSource(source_id) as GeoJSONSource)?.setData({
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [lon, lat]
      },
      properties: {
        heading: 0
      }
    })
  }

  const renderMarkers = () => {
    // Early return if map or ride are not available
    if (!map || !ride) return

    const { start_lat, start_lon, destination_lat, destination_lon } = ride

    // if start position exists in waypoints, set start coordinates to [0, 0]
    const startPosition = waypoints.some(({ lat, lon }) => start_lat === lat && start_lon === lon) ? [0, 0] : [start_lon, start_lat]
    setSourceData(map, 'pickup-marker', startPosition[0], startPosition[1])

    // if destination exists in waypoints, set destination coordinates to [0, 0]
    const endPosition = waypoints.some(({ lat, lon }) => destination_lat === lat && destination_lon === lon) ? [0, 0] : [destination_lon, destination_lat]
    setSourceData(map, 'dropoff-marker', endPosition[0], endPosition[1])
  }

  return null
}

export default RideMarkers

